// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1cC3-iPE"};